export default __webpack_public_path__ + "static/trust-pilot-logo-1b340a3133c7e229929b8951fca6fcf0.svg";